import { render, staticRenderFns } from "./ReportCellsTableAdmin.vue?vue&type=template&id=528347e0&scoped=true"
import script from "./ReportCellsTableAdmin.vue?vue&type=script&lang=js"
export * from "./ReportCellsTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528347e0",
  null
  
)

export default component.exports